import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";

export default function RequireAuth() {
  const location = useLocation();
  const { user, loading } = useAuth();

  if (loading) return null;
  if (!user) return <Navigate to={location.pathname.startsWith("/mrv") ? "/mrv" : "/"} replace />;

  return <Outlet />;
}
